import React from 'react';
import { enterprises } from '../data/profile';
import { Reveal } from './Reveal';
export function TrustStrip() {
  return <section aria-label="Enterprise environments led" className="w-full bg-canvas py-12" data-id="element-429" data-mp="2o53zv5vqzxlu">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-430" data-mp="2jc14cs7eue30">
        <Reveal data-id="element-431" data-mp="2fbh59j3a10e8">
          <p className="text-[11px] font-semibold uppercase tracking-label text-charcoal-muted" data-id="element-432" data-mp="2fc0pj6geg0vf">
            Enterprise environments led
          </p>
          <ul className="mt-7 grid grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-433" data-mp="2adpi12dku2gd">
            {enterprises.map(enterprise => <li key={enterprise.name} className="border-l-2 border-metal/60 pl-4" data-id="element-434" data-mp="20dos2xl7co37">
                <span className="block font-serif text-xl font-semibold tracking-tight text-navy" data-id="element-435" data-mp="1wcmusmauim3v">
                  {enterprise.name}
                </span>
                <span className="mt-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-charcoal-muted" data-id="element-436" data-mp="3urptnq84zp6z">
                  {enterprise.detail}
                </span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}